import type { BundledDuaDescriptor, BundledDuaSourceException } from './types'

// Shared reader metadata must not import Quran/dua text or the combined content barrel.
export type DuaMetadata = {
  id: string
  title: string
  sourceFile: string
  pageCount: number
  estReadTime: number
  sourceException?: BundledDuaSourceException
  intentionalBlankParts?: readonly string[]
}

export const duaMetadata: readonly DuaMetadata[] = [
  {
    id: 'cevsen',
    title: 'Cevşen-i Şerif',
    sourceFile: 'cevsen',
    pageCount: 10,
    estReadTime: 45,
  },
  {
    id: 'celcelutiye',
    title: 'Celcelutiye',
    sourceFile: 'celce',
    pageCount: 10,
    estReadTime: 20,
  },
  {
    id: 'evrad-i-kudsiye',
    title: 'Evrad-ı Kudsiye',
    sourceFile: 'evradiKudsiye',
    pageCount: 10,
    estReadTime: 20,
  },
  {
    id: 'sabah-dualari',
    title: 'Sabah Duaları',
    sourceFile: 'sabahDuasi',
    pageCount: 3,
    estReadTime: 60,
  },
  {
    id: 'aksam-dualari',
    title: 'Akşam Duaları',
    sourceFile: 'aksamDuasi',
    pageCount: 3,
    estReadTime: 60,
  },
  {
    id: 'tahmidiye-duasi',
    title: 'Tahmidiye',
    sourceFile: 'tahmidiye',
    pageCount: 20,
    estReadTime: 15,
  },
  {
    id: 'ashab-i-bedir',
    title: 'Ashab-ı Bedir',
    sourceFile: 'ashabiBedir',
    pageCount: 10,
    estReadTime: 15,
    sourceException: 'latin-only',
  },
  {
    id: 'suheda-i-uhud-duasi',
    title: 'Şüheda-i Uhud',
    sourceFile: 'ashabiUhud',
    pageCount: 9,
    estReadTime: 15,
    sourceException: 'arabic-only',
  },
  {
    id: 'sekine-duasi',
    title: 'Sekine',
    sourceFile: 'sekineDuasi',
    pageCount: 2,
    estReadTime: 20,
  },
  {
    id: 'peygamber-efendimizin-dualari',
    title: 'Peygamber Efendimizin Duaları',
    sourceFile: 'peygamberDualari',
    pageCount: 3,
    estReadTime: 30,
  },
  {
    id: 'ismi-azam-duasi',
    title: 'İsmi Azam',
    sourceFile: 'ismiAzamDuasi',
    pageCount: 3,
    estReadTime: 20,
  },
  {
    id: 'tercumani-ismi-azam-duasi',
    title: 'Tercûman-i İsmi Azam',
    sourceFile: 'tercumaniIsmiAzamDuasi',
    pageCount: 6,
    estReadTime: 15,
  },
  {
    id: 'veysel-karani-munacati',
    title: 'Veysel Karani Munâcâtı',
    sourceFile: 'veyselKaraniMunacati',
    pageCount: 2,
    estReadTime: 20,
  },
  {
    id: 'delailul-nur',
    title: "Delailü'l Nur",
    sourceFile: 'delailulHayratDuasi',
    pageCount: 14,
    estReadTime: 20,
    intentionalBlankParts: ['10:1'],
  },
  {
    id: 'kumeyl-duasi',
    title: 'Kumeyl',
    sourceFile: 'kumeylDuasi',
    pageCount: 7,
    estReadTime: 60,
  },
  {
    id: 'hulasatul-hulasa',
    title: "Hulasatü'l Hulasa",
    sourceFile: 'hulasatulHulasaDuasi',
    pageCount: 13,
    estReadTime: 20,
  },
  {
    id: 'munacatul-kuran-duasi',
    title: "Münâcâtü'l-Kur'ân",
    sourceFile: 'munacatulKuranDuasi',
    pageCount: 16,
    estReadTime: 20,
  },
  {
    id: 'sabah-namazi-tesbihati',
    title: 'Sabah Namazı Tesbihatı',
    sourceFile: 'sabahNamaziTesbihati',
    pageCount: 7,
    estReadTime: 30,
  },
  {
    id: 'ogle-namazi-tesbihati',
    title: 'Öğle Namazı Tesbihatı',
    sourceFile: 'ogleNamaziTesbihati',
    pageCount: 5,
    estReadTime: 20,
    sourceException: 'arabic-only',
  },
  {
    id: 'ikindi-namazi-tesbihati',
    title: 'İkindi Namazı Tesbihatı',
    sourceFile: 'ikindiNamaziTesbihati',
    pageCount: 6,
    estReadTime: 30,
  },
  {
    id: 'aksam-namazi-tesbihati',
    title: 'Akşam Namazı Tesbihatı',
    sourceFile: 'aksamNamaziTesbihati',
    pageCount: 8,
    estReadTime: 20,
    sourceException: 'arabic-only',
  },
  {
    id: 'yatsi-namazi-tesbihati',
    title: 'Yatsı Namazı Tesbihatı',
    sourceFile: 'yatsiNamaziTesbihati',
    pageCount: 5,
    estReadTime: 20,
    sourceException: 'arabic-only',
  },
  {
    id: 'kurandan-rabbena-dualari',
    title: "Kur'an'dan Rabbena Duaları",
    sourceFile: 'rabbenaDualari',
    pageCount: 3,
    estReadTime: 15,
  },
  {
    id: 'namaz-dualari',
    title: 'Namaz Duaları',
    sourceFile: 'namazDualari',
    pageCount: 11,
    estReadTime: 30,
  },
  {
    id: 'salli-barik-duasi',
    title: 'Salli Barik',
    sourceFile: 'salliBarikDuasi',
    pageCount: 1,
    estReadTime: 5,
  },
  {
    id: 'rabbena-duasi',
    title: 'Rabbena',
    sourceFile: 'rabbenaDuasi',
    pageCount: 1,
    estReadTime: 5,
  },
  {
    id: 'esmaul-husna',
    title: 'Esmaül Hüsna',
    sourceFile: 'esmaulHusna',
    pageCount: 3,
    estReadTime: 15,
  },
  {
    id: 'hizbun-nasr-duasi',
    title: 'Abdülkâdir Geylânî’nin Hizbü’n-Nasr Duası',
    sourceFile: 'hizbunNasrDuasi',
    pageCount: 3,
    estReadTime: 10,
  },
  {
    id: 'imam-sazeli-hizbun-nasr-duasi',
    title: 'İmam Şâzilî’nin Hizbü’n-Nasr Duası',
    sourceFile: 'imamSazeliHizbunNasrDuasi',
    pageCount: 3,
    estReadTime: 15,
  },
  {
    id: 'hacet-ve-ferahlik-munacati',
    title: 'Hacet ve Ferahlık Münâcâtı',
    sourceFile: 'hacetVeFerahlikMunacati',
    pageCount: 6,
    estReadTime: 15,
    sourceException: 'arabic-only',
  },
  {
    id: 'hacetleri-allahtan-isteme-duasi',
    title: 'Sahîfe-i Seccâdiye Hacet ve İhtiyaç Duası',
    sourceFile: 'hacetleriAllahtanIstemeDuasi',
    pageCount: 4,
    estReadTime: 10,
  },
  {
    id: 'korunma-duasi',
    title: 'Korunma Duası',
    sourceFile: 'korunmaDuasi',
    pageCount: 6,
    estReadTime: 20,
    sourceException: 'arabic-only',
  },
]

/** Creates a canonical route descriptor for one shared dua dataset. */
function createDescriptor(
  definition: DuaMetadata,
  view: BundledDuaDescriptor['view'],
): BundledDuaDescriptor {
  return {
    type: definition.id,
    slug: definition.id,
    title: definition.title,
    pageCount: definition.pageCount,
    estReadTime: definition.estReadTime,
    datasetId: definition.id,
    sourceFile: definition.sourceFile,
    view,
    sourceException: definition.sourceException,
  }
}

const cevsenDefinition = duaMetadata[0]

/** Canonical web-facing descriptors, including the Cevşen alias route. */
export const bundledDuaDescriptors: readonly BundledDuaDescriptor[] = [
  createDescriptor(cevsenDefinition, 'grouped'),
  {
    type: 'cevsen-i-serif',
    slug: 'cevsen-i-serif',
    title: 'Cevşen-i Şerif (Tekli)',
    pageCount: 101,
    estReadTime: 8,
    datasetId: 'cevsen',
    sourceFile: cevsenDefinition.sourceFile,
    view: 'sections',
    aliasOf: 'cevsen',
  },
  ...duaMetadata.slice(1).map((definition) => createDescriptor(definition, 'sections')),
]
